import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import register1Img from "../../../assets/images/home/register1.jpeg";
import { FiEye, FiEyeOff, FiArrowRight } from "react-icons/fi";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import "../../../assets/css/equipmentrentaladmin/register/Register.css";
import AppContext from "../../../context/AppContext";

export default function RegistrationPage() {
  const navigate = useNavigate();
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [shop, setShop] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errormessage, setErrorMessage] = useState("");
  const { baseUrl, regExpChecker } = useContext(AppContext);

  // ── OTP flow states ──
  const [otpStep, setOtpStep] = useState(false);
  const [otp, setOtp] = useState("");
  const [pendingEmail, setPendingEmail] = useState("");
  const [resendMessage, setResendMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!fullname || !email || !password || !confirmPassword) {
      setErrorMessage("Please fill all fields");
      return;
    }
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match");
      return;
    }
    if (errormessage) return;

    setLoading(true);

    const formdata = new FormData();
    formdata.append("fullname", fullname);
    formdata.append("email", email);
    formdata.append("shop", shop);
    formdata.append("password", password);

    axios.post(`${baseUrl}/rentaladmin/authentication/signup`, formdata)
      .then(() => {
        setLoading(false);
        setPendingEmail(email);
        setOtpStep(true);
        setErrorMessage("");
      })
      .catch((error) => {
        setLoading(false);
        setErrorMessage(error.response?.data?.error || "Registration failed");
      });
  };

  const handleVerifyOtp = () => {
    if (!otp) {
      setErrorMessage("Please enter the OTP");
      return;
    }
    setVerifyLoading(true);

    const formdata = new FormData();
    formdata.append("email", pendingEmail);
    formdata.append("otp", otp);

    axios.post(`${baseUrl}/rentaladmin/authentication/verify-registration-otp`, formdata)
      .then(() => {
        setVerifyLoading(false);
        // 👇 auto-login nahi karna — Login page pe bhej dein, jaisa customer flow mein tha
        navigate("/rental-admin/login");
      })
      .catch((error) => {
        setVerifyLoading(false);
        setErrorMessage(error.response?.data?.error || "OTP verification failed");
      });
  };

  const handleResendOtp = () => {
    const formdata = new FormData();
    formdata.append("email", pendingEmail);

    axios.post(`${baseUrl}/rentaladmin/authentication/resend-registration-otp`, formdata)
      .then(() => {
        setResendMessage("OTP resent to your email");
        setErrorMessage("");
      })
      .catch((error) => {
        setErrorMessage(error.response?.data?.error || "Could not resend OTP");
      });
  };

  return (
    <div className="fleet-container">

      {/* LEFT PANEL */}
      <div className="fleet-left"
        style={{
          backgroundImage: `url(${register1Img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}>
        <div className="fleet-left-overlay" />
        <div className="fleet-left-content">
          <span className="owner-badge">FOR EQUIPMENT OWNERS</span>
          <h1>Maximize Your Fleet's <br /> Potential</h1>
          <p>
            Join the premier network for agricultural machinery management.
            Track maintenance, manage rentals, and optimize performance.
          </p>
        </div>
      </div>

      {/* RIGHT PANEL */}
      <div className="fleet-right">
        <div className="reg-form-wrapper">
          <div className="reg-form-card">

            {!otpStep ? (
              <>
                <h2>Create Owner Account</h2>
                <p>Enter your details below to register your equipment fleet.</p>

                <form onSubmit={handleSubmit}>

                  {/* Full Name */}
                  <div className="reg-form-group">
                    <label>Full Name</label>
                    <div className="reg-input-wrapper">
                      <input
                        type="text"
                        placeholder="e.g. John Doe"
                        value={fullname}
                        onChange={(e) => {
                          setFullname(e.target.value);
                          setErrorMessage(regExpChecker("username", e.target.value));
                        }}
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <div className="reg-form-group">
                    <label>Email Address</label>
                    <div className="reg-input-wrapper">
                      <input
                        type="email"
                        placeholder="name@company.com"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setErrorMessage(regExpChecker("email", e.target.value));
                        }}
                        required
                      />
                    </div>
                  </div>

                  {/* Passwords */}
                  <div className="password-row">
                    <div className="reg-form-group">
                      <label>Password</label>
                      <div className="reg-input-wrapper">
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder="••••••••"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                            setErrorMessage(regExpChecker("password", e.target.value));
                          }}
                        />
                        <button type="button" className="eye-btn" onClick={() => setShowPassword(!showPassword)}>
                          {showPassword ? <FiEyeOff /> : <FiEye />}
                        </button>
                      </div>
                    </div>

                    <div className="reg-form-group">
                      <label>Confirm Password</label>
                      <div className="reg-input-wrapper">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          placeholder="••••••••"
                          value={confirmPassword}
                          onChange={(e) => {
                            const value = e.target.value;
                            setConfirmPassword(value);
                            if (value !== password) {
                              setErrorMessage("Passwords do not match");
                            } else {
                              setErrorMessage("");
                            }
                          }}
                        />
                        <button type="button" className="eye-btn" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                          {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                        </button>
                      </div>
                    </div>
                  </div>

                  {errormessage && <p style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>{errormessage}</p>}

                  <button type="submit" className="submit-btn" disabled={loading}>
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" style={{ marginRight: "8px" }} />
                        Registering...
                      </>
                    ) : (
                      <>
                        Register Account <FiArrowRight />
                      </>
                    )}
                  </button>

                  {/* Already have an account? Login */}
                  <p style={{
                    textAlign: "center",
                    marginTop: "18px",
                    fontSize: "0.875rem",
                    color: "#555",
                    fontFamily: "'Poppins', sans-serif"
                  }}>
                    Already have an account?{" "}
                    <span
                      onClick={() => navigate("/rental-admin/login")}
                      style={{
                        color: "#FDB714",
                        fontWeight: "600",
                        cursor: "pointer",
                        textDecoration: "underline"
                      }}
                    >
                      Login
                    </span>
                  </p>

                </form>
              </>
            ) : (
              <>
                <h2>Verify Your Email</h2>
                <p>
                  We sent a 6-digit code to <b>{pendingEmail}</b>. Enter it below to activate your account.
                </p>

                <div className="reg-form-group">
                  <label>Enter OTP</label>
                  <div className="reg-input-wrapper">
                    <input
                      type="text"
                      placeholder="6-digit code"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      maxLength={6}
                    />
                  </div>
                </div>

                {errormessage && <p style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>{errormessage}</p>}
                {resendMessage && <p style={{ color: "green", fontSize: "0.8rem", marginTop: "4px" }}>{resendMessage}</p>}

                <button type="button" className="submit-btn" onClick={handleVerifyOtp} disabled={verifyLoading}>
                  {verifyLoading ? (
                    <>
                      <Spinner animation="border" size="sm" style={{ marginRight: "8px" }} />
                      Verifying...
                    </>
                  ) : (
                    <>
                      Verify OTP <FiArrowRight />
                    </>
                  )}
                </button>

                <p style={{
                  textAlign: "center",
                  marginTop: "18px",
                  fontSize: "0.875rem",
                  color: "#555",
                  fontFamily: "'Poppins', sans-serif"
                }}>
                  Didn't receive the code?{" "}
                  <span
                    onClick={handleResendOtp}
                    style={{
                      color: "#FDB714",
                      fontWeight: "600",
                      cursor: "pointer",
                      textDecoration: "underline"
                    }}
                  >
                    Resend OTP
                  </span>
                </p>
              </>
            )}

          </div>
        </div>
      </div>

    </div>
  );
}